import React from 'react';

import Button from '@material-ui/core/Button';
import LinearProgress from '@material-ui/core/LinearProgress';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  pendingIndicator: {
    bottom: 0,
    display: 'flex',
    left: 0,
    position: 'absolute',
    right: 0,
    visibility: 'visible',
  },
}));

export default ({ children, loading = false, disabled = false, ...other }) => {
  const classes = useStyles();

  return (
    <Button disabled={disabled || loading} {...other}>
      {loading && (
        <div className={classes.pendingIndicator}>
          <LinearProgress style={{ height: '2px', width: '100%' }} />
        </div>
      )}
      {children}
    </Button>
  );
};
